import { combineReducers } from 'redux';
import { createReducer } from 'typesafe-actions';

import { fetchServiceConditionsAsync } from './actions';

import type { ServiceConditionErrors, ServiceConditionResponse } from 'ServiceCondition-Types';
export const isFetching = createReducer(false as boolean)
  .handleAction([fetchServiceConditionsAsync.request], () => true)
  .handleAction(
    [fetchServiceConditionsAsync.success, fetchServiceConditionsAsync.failure],
    () => false,
  );

export const conditions = createReducer({} as ServiceConditionResponse).handleAction(
  fetchServiceConditionsAsync.success,
  (_state, action) => action.payload,
);

export const errors = createReducer([] as ServiceConditionErrors[]).handleAction(
  fetchServiceConditionsAsync.failure,
  (_state, action) => action.payload,
);

const serviceConditionsReducer = combineReducers({
  isFetching,
  conditions,
  errors,
});

export default serviceConditionsReducer;
export type ServiceConditionState = ReturnType<typeof serviceConditionsReducer>;
